import { Routes, Route } from "react-router-dom";
import { MainProvider } from "./contexts/main";

import LayoutMain from "./layouts/main";
import PageIndex from "./pages/index";
import LiffNdcflLink from "./pages/liff/ndcfl/link";

function App() {
  return (
    <MainProvider className="root_app">
      <Routes>
        <Route element={<LayoutMain />}>
          <Route exact path="/" element={<PageIndex />} />
          <Route exact path="/liff/ndcfl/link" element={<LiffNdcflLink />} />
          <Route path="*" element={<div>Notfound</div>} />
        </Route>
      </Routes>
    </MainProvider>
  );
}

export default App;
